import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./authForms.scss";
import { useLogin } from "../../../hooks/useLogin";

const ForgotPassForm = () => {
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState(null);
  const { resetPassword, isLoading } = useLogin();

  const handelResetPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await resetPassword(email);
      if (response === "success") {
        setAlert({
          variant: "success",
          message: "Password reset token sent to your email.",
        });
      } else if (response.response.status === 400) {
        setAlert({
          variant: "danger",
          message: response.response.data.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-div">
        {alert && (
          <Alert
            variant={alert.variant}
            onClose={() => setAlert(null)}
            dismissible
          >
            {alert.message}
          </Alert>
        )}

        <Form className="form-box">
          <Form.Group className="mb-3 box-form" controlId="formBasicEmail">
            <Form.Label className="text-above-box">Enter email</Form.Label>
            <Form.Control
              type="email"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </Form.Group>
          <div className="d-grid gap-2">
            <Button
              variant="btn btn-primary login-buttomn"
              type="submit"
              onClick={handelResetPassword}
            >
              Reset Password
            </Button>
          </div>

          <h6 className="form-register-link">
            Return to{" "}
            <Link to="/" className="link-to">
              login
            </Link>{" "}
            page.
          </h6>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassForm;
